'use client';

import Link from 'next/link';

const links = [
  { label: 'Product', href: '#workflow' },
  { label: 'Features', href: '#talk' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'FAQ', href: '#faq' },
];

export default function MarketingNav() {
  return (
    <nav className="fixed top-0 z-50 w-full border-b border-white/10 bg-mk-surface/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-[1280px] items-center justify-between px-6 py-4">
        <Link
          href="/"
          className="font-mk-display text-3xl tracking-tight text-mk-ink"
        >
          RECLIPT
        </Link>

        <div className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="font-mk-label text-xs font-bold uppercase tracking-[0.18em] text-mk-muted transition-colors hover:text-mk-pink"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <Link
            href="/login"
            className="hidden font-mk-label text-xs font-bold uppercase tracking-[0.18em] text-mk-muted transition-colors hover:text-mk-ink sm:inline"
          >
            Sign In
          </Link>
          <Link
            href="/register"
            className="rounded-full bg-mk-pink px-6 py-2 font-mk-label text-xs font-bold uppercase tracking-[0.18em] text-mk-on-pink transition-transform hover:scale-105 active:scale-95"
          >
            Get Started
          </Link>
        </div>
      </div>
    </nav>
  );
}
